import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AdminTableAction } from "stores/AdminVendorStore/AdminTableAction";
import { VendorActions } from "stores/VendorStore/vendorAction";

const mapStateToProps = (state) => {
  return {
    AdminTableList: state.AdminTable.AdminTableList,
    VendorListisLoading: state.AdminTable.AdminTable.isLoading,
    VendorCityList: state.Vendors.VendorCityList,
    VendorCountList: state.Vendors.VendorCountList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // getVendor: VendorActions.getVendor,
      getAdminTableAction: AdminTableAction.getAdminTable,
      getVendorCityAction: VendorActions.getVendorCity,
      getVendorCountAction: VendorActions.getVendorCount,
      postVendorRequestAction: VendorActions.postVendorRequest,
    },
    dispatch
  );

const VendorStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VendorStore;
